import { flatsListAPI } from "./api";

export const getFlatsList = async (params = {}) => {
  try {
    const res = await flatsListAPI.getList(params);
    return res?.data;
  } catch (e) {}
};
export const getResidencyOptions = async () => {
  try {
    const res = await flatsListAPI.getResidents();
    return res?.data;
  } catch (e) {}
};
export const getEntranceOptions = async (resident_id) => {
  try {
    const res = await flatsListAPI.getEntrances(resident_id);
    return res?.data;
  } catch (e) {}
};
export const updateFlat = async (body) => {
  try {
    const res = await flatsListAPI.updateFlat(body);
    return res?.data;
  } catch (e) {}
};
export const cloneFlat = async (body) => {
  try {
    const res = await flatsListAPI.cloneFlat(body);
    return res?.data;
  } catch (e) {}
};
export const deleteFlat = async (flat_id) => {
  try {
    const res = await flatsListAPI.deleteFlat(flat_id);
    return res?.data;
  } catch (e) {}
};

export const flatsListColumns = [
  {
    name: "flat_id",
    field: "flat_id",
    label: "flat_id",
    align: "center",
  },
  {
    name: "entrance",
    field: "entrance",
    label: "Подъезд",
    align: "center",
  },
  {
    name: "floor",
    field: "floor",
    label: "Этаж",
    align: "center",
  },
  {
    name: "is_active",
    field: "is_active",
    label: "Активный",
    align: "center",
  },
  {
    name: "copy",
    label: "Дублировать",
    align: "center",
    headerStyle: "width: 50px",
    style: "width: 50px",
  },
  {
    name: "edit",
    label: "Редактировать",
    align: "center",
    headerStyle: "width: 50px",
    style: "width: 50px",
  },
];
